<app-statistik-normtid-options class="d-flex"
                               (periodeChange)="onPeriodeChange($event)"
                               (exportExcel)="onExport()"
                               (selectDecimal)="onDecimalSelected($event)"
                               (selectDeciminuts)="onDeciminutsSelected($event)"
                               (selectGruppe)="onSelectGruppe($event)"
                               [periode]="periode"
></app-statistik-normtid-options>


<div class="table__viewport">
    <table *ngIf="statistikNormTid" class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
        <tr>
            <th (click)="toggleAfdelinger()">Afdeling</th>
            <th>Navn</th>
            <ng-container *ngFor="let monthIndex of monthIndexArray">
                <th colspan="2" class="text-center">{{getMonth(monthOrder[monthIndex])}}</th>
            </ng-container>
            <th colspan="2" class="text-center">Total</th>
        </tr>
        <tr>
            <th></th>
            <th></th>
            <ng-container *ngFor="let month of months">
                <th class="text-center">N</th>
                <th class="text-center">P</th>
            </ng-container>
            <th class="text-center">N</th>
            <th class="text-center">P</th>
        </tr>
        </thead>

        <tbody>
            <ng-container *ngFor="let afdeling of getUniqueAfdelinger(); trackBy: trackAfdelingNavn">
                <ng-container *ngFor="let medarbejder of getMedarbejderFromAfdeling(afdeling); trackBy: trackMedarbejderInit">
                    <tr class="item__tr" *ngIf="isMedarbejderVisible(medarbejder) && isMedarbejderInSelectedGruppe(medarbejder)">
                        <td>{{medarbejder.afdeling || 'Ikke angivet'}}</td>
                        <td>{{medarbejder.medNavn}}</td>
                        <ng-container *ngFor="let monthIndex of monthIndexArray">
                            <td class="text-center">{{getTotalNormtidPerMonthPerMedarbejder(medarbejder, monthOrder[monthIndex]+1) | timeKrFormat: 'Timer': decimal: inDeciminuts }}</td>
                            <td class="text-center link"
                                (click)="OpenTimebudgetModal(getTotalPlantidPerMonthPerMedarbejder(medarbejder, monthOrder[monthIndex]+1), monthOrder[monthIndex]+1, medarbejder)">{{getTotalPlantidPerMonthPerMedarbejder(medarbejder, monthOrder[monthIndex]+1) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</td>
                        </ng-container>
                        <td class="text-center">{{getTotalNormtidPerYearPerMedarbejder(medarbejder) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</td>
                        <td class="text-center">{{getTotalPlantidPerYearPerMedarbejder(medarbejder) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</td>
                    </tr>
                </ng-container>

                <tr *ngIf="getUniqueAfdelinger().length > 1" (click)="toggleAfdeling(afdeling)" class="total__tr">
                    <th><i [ngClass]="expandedAfdelinger.includes(afdeling) ? 'fa fa-caret-up' : 'fa fa-caret-right'"></i>Total {{afdeling}}</th>
                    <th></th>
                    <ng-container *ngFor="let monthIndex of monthIndexArray">
                        <th class="text-center">{{getTotalNormtidPerMonth(getMedarbejderFromAfdeling(afdeling), monthOrder[monthIndex]+1) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</th>
                        <th class="text-center">{{getTotalPlantidPerMonth(getMedarbejderFromAfdeling(afdeling), monthOrder[monthIndex]+1) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</th>
                    </ng-container>
                    <th class="text-center">{{getTotalNormtidPerYear(getMedarbejderFromAfdeling(afdeling)) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</th>
                    <th class="text-center">{{getTotalPlantidPerYear(getMedarbejderFromAfdeling(afdeling)) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</th>
                </tr>
            </ng-container>
        </tbody>

        <tfoot class="fixed-bottom position-fixed position-sticky">
        <tr>
            <th>Total</th>
            <th></th>
            <ng-container *ngFor="let monthIndex of monthIndexArray">
                <th class="text-center">{{getTotalNormtidPerMonth(statistikNormTid, monthOrder[monthIndex]+1) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</th>
                <th class="text-center">{{getTotalPlantidPerMonth(statistikNormTid, monthOrder[monthIndex]+1)| timeKrFormat: 'Timer': decimal: inDeciminuts}}</th>
            </ng-container>
            <th class="text-center">{{getTotalNormtidPerYear(statistikNormTid) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</th>
            <th class="text-center">{{getTotalPlantidPerYear(statistikNormTid) | timeKrFormat: 'Timer': decimal: inDeciminuts}}</th>
        </tr>
        </tfoot>

    </table>
</div>
